<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <h1 class="md-headline text-right">{{ translations[$store.state.lang].home.title }}</h1>
        <h2 class="md-subheading text-right">Museu d'Història de Manacor</h2>
        <div class="places" v-if="$store.state.places">
          <md-card v-for="place in $store.state.places" :key="place.uuid[0].value">
            <md-card-media-cover>
              <md-card-media>
                <img :src="place.field_image[0].url|imageStyle" :alt="place.field_image[0].alt">
              </md-card-media>
              <md-card-area>
                <md-card-header>
                  <router-link :to="{name: 'term', params: {lang: $store.state.lang, tid: place.tid[0].value}}">
                    <span class="md-title">{{ place.name[0].value }}</span>
                  </router-link>
                </md-card-header>
              </md-card-area>
            </md-card-media-cover>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { LANG } from "@/lang";

    export default {
        name: 'vue-home',
        metaInfo: {
            title: "Inici",
            titleTemplate: '%s | Museu d\'Història de Manacor'
        },
        data() {
            return {
                translations: LANG,
            }
        },
        filters: {
            imageStyle(value) {
                return value.replace('/sites/default/files/', '/sites/default/files/styles/mobile/public/') + '.jpg';
            }
        }
    }
</script>
